import { handleResponse } from '../../../../resources/shared/types/handlers';
import { Paginated } from '../../../../resources/shared/types/pagination';
import { generateUrl } from '../../../../shared/utilities/routing/routing';
import { Locale } from '../../../i18n/Locale';
import {
    FetchFiltersTripReviews,
    FetchSortTripReviews,
    NormalizedTripReview,
} from '../../PublicWebsite/Resources/tripReview/tripReview';
import { frontApiUrl } from '../url';

export async function getAgencyTripReviews({
    agencyId,
    locale,
    page,
    perPage,
    sort,
    filters,
}: {
    agencyId: number;
    locale: Locale;
    page: number;
    perPage: number;
    sort?: FetchSortTripReviews;
    filters?: Array<FetchFiltersTripReviews>;
}): Promise<Paginated<NormalizedTripReview>> {
    return fetchTripReviews({
        agencyId,
        locale,
        page,
        perPage,
        sort,
        filters,
    });
}

export async function getDestinationTripReviews({
    destinationId,
    locale,
    page,
    perPage,
    sort,
}: {
    destinationId: number;
    locale: Locale;
    page: number;
    perPage: number;
    sort?: FetchSortTripReviews;
}): Promise<Paginated<NormalizedTripReview>> {
    return fetchTripReviews({
        destinationId,
        locale,
        page,
        perPage,
        sort,
    });
}

async function fetchTripReviews({
    locale,
    page,
    perPage,
    agencyId,
    destinationId,
    sort,
    filters,
}: {
    locale: Locale;
    page: number;
    perPage: number;
    agencyId?: number;
    destinationId?: number;
    sort?: FetchSortTripReviews;
    filters?: Array<FetchFiltersTripReviews>;
}) {
    const response = await fetch(
        frontApiUrl(
            generateUrl('api_trip_reviews', locale, {
                locale,
                page,
                perPage,
                ...(agencyId ? { agencyId } : {}),
                ...(destinationId ? { destinationId } : {}),
                ...(sort ? { [`sorts[${sort.key}]`]: sort.value } : {}),
                rating: filters?.map((filter) => filter.key === 'rating' && filter.value).join(','),
            }),
        ),
    );

    return handleResponse<Paginated<NormalizedTripReview>>(response);
}

export async function getTripReviews({
    locale,
    page,
    perPage,
}: {
    locale: Locale;
    page: number;
    perPage: number;
}): Promise<Paginated<NormalizedTripReview>> {
    return fetchTripReviews({
        locale,
        page,
        perPage,
    });
}
